module.exports = __webpack_public_path__ + "img/thumb_2021-02.c46747ee.jpg";